import React, { useEffect, useState } from 'react';
import CashSettings from './CashSettings';
import DistributorPurchaseConfiguration from '../distributor-admin/DistributorPurchaseConfiguration';
import CashFundingSettings from './CashFundingSettings';
import CashBankActivation from './CashBankActivation';

export default function CashSetupConfiguration({
  distributor,
  disabled,
  onLockChange,
  workspaceAdmin = false,
}) {
  const [cashLocked, setCashLocked] = useState(false);
  const [purchaseLocked, setPurchaseLocked] = useState(false);
  const [mode, setMode] = useState(null);
  const [fundingLocked, setFundingLocked] = useState(false);
  const [activationLocked, setActivationLocked] = useState(false);
  const [activationVersion, setActivationVersion] = useState(0);
  useEffect(() => {
    onLockChange(cashLocked || purchaseLocked || fundingLocked || activationLocked);
    return () => onLockChange(false);
  }, [cashLocked, purchaseLocked, fundingLocked, activationLocked, onLockChange]);
  return (
    <>
      <CashSettings
        key={`settings-${activationVersion}`}
        distributorId={distributor._id}
        disabled={disabled || purchaseLocked || fundingLocked || activationLocked}
        onLockChange={setCashLocked}
        onModeChange={setMode}
      />
      <CashBankActivation
        distributorId={distributor._id}
        disabled={disabled || cashLocked || purchaseLocked || fundingLocked}
        onLockChange={setActivationLocked}
        onUpdated={() => setActivationVersion((value) => value + 1)}
      />
      <CashFundingSettings
        key={`funding-${activationVersion}`}
        distributor={distributor}
        disabled={disabled || cashLocked || purchaseLocked || activationLocked}
        onLockChange={setFundingLocked}
      />
      <DistributorPurchaseConfiguration
        workspaceAdmin={workspaceAdmin}
        distributor={distributor}
        disabled={disabled || cashLocked || fundingLocked || activationLocked}
        onLockChange={setPurchaseLocked}
        cashMode={mode === 'cash'}
        legacyAvailable={mode === 'legacy'}
      />
    </>
  );
}
